import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useFooterStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    padding: hubloTheme.spacing(1.5, 2),
  },
  container: {
    width: '100%',

    [hubloTheme.breakpoints.up('lg')]: {
      maxWidth: 568,
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
    },
  },
  fullWidth: {
    width: '100%',
  },
}))
